export function getListHeader(subTypeCode:any, pageTitle:string , isWorkflowModel:boolean):any{
return {
  type: "fgrow",
  id: "12223aaa",
  name: "Row",
  icon: "fa fa-bars",
  config: false,
  logo: "fgrow",
  condition: {},
  isCoreConfig: true,
  children: [
    {
      type: "fgcol",
      subtype: "dynamic",
      icon: "fa fa-columns",
      config: true,
      logo: "fgcol",
      name: "Dynamic Column",
      category: "GRIDS",
      uuid: crypto.randomUUID(),
      children: [
        {
          type: "fgword",
          subtype: "h4",
          cat: "HEADING",
          icon: "fa fa-square-o",
          name: "Heading 4",
          text: pageTitle,
          condition: {},
          isCoreConfig: true,
          category: "STATIC",
          uuid: crypto.randomUUID(),
          textAlign: "text-left",
          styles: {},
          customClass: "pt-2"
        }
      ],
      condition: {},
      styles: {},
      customStyle: "max-width: max-content;"
    },
    {
      type: "fgcol",
      subtype: "dynamic",
      icon: "fa fa-columns",
      config: true,
      logo: "fgcol",
      name: "Dynamic Column",
      category: "GRIDS",
      uuid: crypto.randomUUID(),
      children: [
         getFlowTabs(isWorkflowModel)
      ],
      condition: {},
      styles: {}
    },
    {
      type: "fgcol",
      subtype: "dynamic",
      icon: "fa fa-columns",
      config: true,
      logo: "fgcol",
      name: "Dynamic Column",
      category: "GRIDS",
      uuid: crypto.randomUUID(),
      children: [
        {
          type: "fgcustomcontainer",
          name: "Custom Container",
          icon: "fa fa-square-o",
          class: "card-default",
          header: true,
          heading: " some heading",
          config: true,
          children: [
            {
              type: "fgbuttonaction",
              subtype: "formaction",
              icon: "fa fa-plus",
              name: "Form Button",
              condition: {},
              isCoreConfig: true,
              category: "ACTIONS",
              uuid: crypto.randomUUID(),
              setValueConfig: {},
              messageConfigs: "aftereSubmitMessage",
              messageConfig: {},
              afterMessageConfigs: {},
              option: { page: {} },
              customReqFieldConfig: {},
              styles: {},
              label: "Cancel",
              dynamicLabel: false,
              actionCode: "Cancel",
              customStyle: "",
              buttonClass: "",
              customClass: "fg-tertiary-button"
            },
            {
              type: "fgbuttonaction",
              subtype: "formaction",
              icon: "fa fa-plus",
              name: "Form Button",
              condition: {},
              isCoreConfig: true,
              category: "ACTIONS",
              uuid: crypto.randomUUID(),
              actionPurposeCode: "authorise",
              setValueConfig: {},
              messageConfigs: "aftereSubmitMessage",
              messageConfig: {},
              afterMessageConfigs: {},
              option: { page: {} },
              customReqFieldConfig: {},
              styles: {},
              label: "open filter",
              dynamicLabel: false,
              actionCode: "Modal",
              modalProperty: "FG_FILTER"
            }
          ],
          condition: {},
          isCoreConfig: true,
          category: "LAYOUT",
          uuid: crypto.randomUUID(),
          displayContainer: "CONTAINER_FLUID",
          styles: {},
          textAlign: "END"
        }
      ],
      condition: {},
      styles: {},
      customClass: "text-right"
    }
  ],
  category: "GRIDS",
  uuid: crypto.randomUUID(),
  rowClass: ""
};

function getFlowTabs(isWorkflowModel:any):any{
  if(!isWorkflowModel) return "" ;
  else
  return {
          type: "fgDynamicTabs",
          name: "Dynamic Tabs",
          icon: "fa fa-columns",
          config: true,
          condition: {},
          isCoreConfig: true,
          children: [
            {
              data: {
                SCORECOUNT: 13,
                STATUS_CODE: "APPROVED"
              },
              name: "APPROVED",
              displayName: "Active"
            },
            {
              data: {
                SCORECOUNT: 0
              },
              name: "PENDING",
              displayName: "Pending"
            },
            {
              data: {
                SCORECOUNT: 3,
                STATUS_CODE: "NEW"
              },
              name: "NEW",
              displayName: "Drafts"
            }
          ],
          category: "LAYOUT",
          uuid: crypto.randomUUID(),
          customTabConfig: {
            tabCode: "NEW",
            displayLabel: "Drafts"
          },
          customTab: {
            fields: [
              { tabCode: "APPROVED", displayLabel: "Active" },
              { tabCode: "PENDING", displayLabel: "Pending" },
              { tabCode: "NEW", displayLabel: "Drafts" }
            ]
          },
          queryConfig: {
            measureField: [],
            measureFieldAggregation: "count",
            model: subTypeCode,
            dimensionField: [
              {
                tag: "System",
                name: "STATUS_CODE",
                type: "text",
                displayName: "StatusCode",
                description: null,
                defaultValue: null,
                systemDefined: true,
                isEditable: null,
                isSearchable: true,
                isGroupable: null,
                isSortable: null,
                isAuditable: null,
                isWorkflowEnabled: null,
                minLength: 0,
                maxLength: 30,
                isUnique: null,
                isMandatory: false,
                isPrimaryKey: null,
                isLink: null,
                isCopy: null,
                pattern: null,
                prefix: null,
                suffix: null,
                isMesurable: true,
                isDimensional: true,
                isParty: null,
                lookUpReference: {
                  lookupCode: null,
                  filterField: null,
                  filterValue: null,
                  displayField: null,
                  valueField: null,
                  defaultValue: null,
                  dataSourceValues: null,
                  filtersList: null,
                  isCustomService: null,
                  customServiceBean: null,
                  customServiceMethod: null,
                  datasetId: null,
                  lookupPage: null,
                  roles: null
                },
                fieldType: null,
                filterLookUpReference: {
                  lookupCode: null,
                  filterField: null,
                  filterValue: null,
                  displayField: null,
                  valueField: null,
                  defaultValue: null,
                  dataSourceValues: null,
                  filtersList: null,
                  isCustomService: null,
                  customServiceBean: null,
                  customServiceMethod: null,
                  datasetId: null,
                  lookupPage: null,
                  roles: null
                },
                fieldTypeKey: null,
                isAuthflowEnabled: null,
                isSecured: null,
                translationFieldCode: null,
                isNonPersistField: null,
                isConfirmationField: null,
                isAcknowledgementField: null,
                identifierKey: null,
                authflowResolver: null,
                weight: 0,
                isIndexing: null,
                modelCode:subTypeCode,
                isFreeText: null,
                isFacet: null,
                securityType: null,
                encryptionType: null,
                algorithm: null,
                persistWithMasking: null,
                maskChar: null,
                maskStart: null,
                maskEnd: null,
                isEncryptionEnabled: null,
                translationValueField: null,
                translationDisplayField: null,
                isDynamicField: null,
                dynamicFieldExpression: null,
                isObjectSecurity: null
              }
            ],
            isSecondaryMeasureFieldsEnabled: false,
            roles: ["CUSTOMER"],
            conditions: [],
            enableAdditionalModels: true,
            additionalModels: []
          },
          option: { page: {} },
          pagination: {},
          styles: {},
          isManualBindingKey: true,
          key: "STATUS_CODE",
          showCount: true,
          showCountAsBadge: true,
          showAllTab: false,
          allTabLabel: "All",
          allPosition: "LAST",
          isCustomTabFieldsEnabled: true,
          enableAdditionalModels: false
        }
}

}


